// tslint:disable: no-unused-expression
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'setPercentage' })
export class SetPercentagePipe implements PipeTransform {

  /* transform(): Pipe que formatea un número a "n" decimales y permite aplicar minimo y maximo porcentual
    value: El valor porcentual a formatear
    max: Bandera para saber si aplicar maximo y minimo porcentual (0, 100)
    decimals: define con cuantos decimales se mostrara el valor
  */
  transform(value: any, max: boolean = false, decimals: number = 0): number {
    // verifica si la bandera está activada
    if (max) { value > 100 ? value = 100 : null; value < 0 ? value = 0 : null; }
    // Devuelve el número formateado
    return Number.parseFloat(Number.parseFloat(value).toFixed(decimals));
  }

}
